'use client';

import { Loader2 } from 'lucide-react';
import * as React from 'react';

import { SetupProcessorEmbedProvider } from '@/components/setup/experience/SetupProcessorEmbedContext';
import { getSetupProcessorEditComponent } from '@/components/setup/experience/lib/setupProcessorEditRegistry';

interface SetupProcessorEditEmbedProps {
  processorId: string;
  processorType: string;
  onCancel: () => void;
  onComplete: () => void;
}

export function SetupProcessorEditEmbed({
  processorId,
  processorType,
  onCancel,
  onComplete,
}: SetupProcessorEditEmbedProps) {
  const EditComponent = getSetupProcessorEditComponent(processorType);

  if (!EditComponent) {
    return (
      <p
        className="text-destructive m-0 rounded-md bg-[color-mix(in_srgb,var(--destructive)_8%,var(--background))] px-3 py-2.5 text-xs"
        role="alert"
      >
        Unsupported processor type.
      </p>
    );
  }

  return (
    <SetupProcessorEmbedProvider processorId={processorId} onCancel={onCancel} onComplete={onComplete}>
      <div className="setup-xp-processor-dialog__configure crm-processor-edit-shell">
        <React.Suspense
          fallback={
            <div
              className="text-primary flex min-h-40 items-center justify-center"
              role="status"
              aria-live="polite"
            >
              <Loader2 className="size-5 animate-spin" aria-hidden />
            </div>
          }
        >
          <EditComponent />
        </React.Suspense>
      </div>
    </SetupProcessorEmbedProvider>
  );
}
